import { type FC } from 'react';
import cn from 'classnames';

import { selectCurrentInProgressLoteryData } from '@/redux/selectors/lotterySelector';
import { useAppSelector } from '@/redux/store';

import { RewardForPlace } from './RewardForPlace/RewardForPlace';

interface TopPlaceRewardsProps {
  className?: string;
}

const TopPlaceRewards: FC<TopPlaceRewardsProps> = ({ className }) => {
  const currentEvent = useAppSelector(selectCurrentInProgressLoteryData);

  return (
    currentEvent && (
      <div
        className={cn('w-full flex gap-8 items-end justify-center', className)}
      >
        <RewardForPlace
          className="order-1"
          place={1}
          reward={currentEvent.rewards['1']}
        />
        <RewardForPlace
          className="order-0"
          place={2}
          reward={currentEvent.rewards['2']}
        />
        <RewardForPlace
          className="order-3"
          place={3}
          reward={currentEvent.rewards['3']}
        />
      </div>
    )
  );
};

export { TopPlaceRewards };
